import { render, staticRenderFns } from "./ModalDetails.vue?vue&type=template&id=5b1c8a80&"
import script from "./ModalDetails.vue?vue&type=script&lang=js&"
export * from "./ModalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports